require './last-minute-modal.js'
{ documentReady } = require '@grpn/document-states';
urlUtils = require '../../shared/frontend/url-utils'
paginationCard = require '../../shared/frontend/pagination-card'
cardUI = require 'grpn-card-ui/lib/frontend/init'
Filtering = require '../../shared/frontend/filtering'

pageConfig = {}

documentReady.then ()->
  BOOMR["app_name"] = "{{appName}}"
  positionDFPMerchandisingBanners()
  positionInAppMessages()
  pageConfig = Groupon.Utils.getConfigFromDom()

  if document.querySelector(".main.row.module.giftable") # WARNING: unlike most events, enterviewport will fire synchronously - any error will prevent additional listeners from being attached and hault this init function
    ViewportObserver.watchViewportEnter document.querySelectorAll('#category-deals.viewport-load .deal-load[data-deal-type]'), loadThemeDeals
  if window.location.href.indexOf('show-gift-modal=true') > 5
    showLastMinuteModal()

  createFacetArea() # web template does not provide this, create one!

  Filtering.init pageConfig, true, '', ()->
    # filtering init completed
    setTimeout initAtEnd, 0

initAtEnd = () ->
  Filtering.initCui()
  setupSidebarToggles()
  Groupon.Performance.pageReady() # should always call this last

createFacetArea = () ->
  dest = document.querySelector("#sidebar-lists .gift-sidebar li.selected")
  classes = 'indent'
  modeAppend = true # appendTo
  if not dest
    dest = document.querySelector('#fallback-facet-area')
    classes = 'standalone'
    modeAppend = false # insertAfter
  if dest
    liHolder = document.createElement('ul')
    liHolder.id = 'facet-filters'
    liHolder.setAttribute('class', classes+' nav-facets gift-sidebar')
    liHolder.setAttribute('style', 'display:none;')
    if modeAppend
      dest.appendChild(liHolder)
    else
      dest.after(liHolder)

setupSidebarToggles = () ->
  sidebarToggle = document.getElementById('sidebar-toggle')
  if sidebarToggle
    sidebarToggle.classList.remove('hide-narrow')
    sidebarToggle.querySelector('button').addEventListener('click', toggleSidebar)
    document.getElementById('sidebar-lists-overlay').addEventListener('mousedown', toggleSidebar)
    document.querySelector('#sidebar-lists .close-x').addEventListener('mousedown', toggleSidebar)

hideSidebar = (ev) ->
  if ev.keyCode == 27
    toggleSidebar()

toggleSidebar = () ->
  btn = document.querySelector('#sidebar-toggle button')
  sidebar = document.getElementById('sidebar-lists')
  overlay = document.getElementById('sidebar-lists-overlay')
  cls_expanded_btn = 'btn'
  cls_colapsed_btn = 'btn-invert'
  cls_show_sheet = 'show'
  cls_footer_glow = 'ls-footer-glow'
  shown = sidebar.classList.contains(cls_show_sheet)
  if shown
    btn.classList.remove(cls_expanded_btn)
    btn.classList.add(cls_colapsed_btn)
    sidebar.classList.remove(cls_show_sheet)
    overlay.classList.remove(cls_show_sheet)
    document.body.classList.remove cls_footer_glow
    document.body.removeEventListener('keyup', hideSidebar)
  else
    btn.classList.remove(cls_colapsed_btn)
    btn.classList.add(cls_expanded_btn)
    sidebar.classList.add(cls_show_sheet)
    overlay.classList.add(cls_show_sheet)
    document.body.classList.add cls_footer_glow
    document.body.addEventListener('keyup', hideSidebar)


hideThemeRow = (dealRow) ->
  section = dealRow.closest('section')
  if section
    section.style.display = 'none'
    ViewportObserver.viewScrolled()

loadThemeDeals = (ev)->
  dealRow = ev.target
  if dealRow
    resultNodes = dealRow.querySelectorAll("li")
    query_filter_string = urlUtils.apiQueryBuilder paginationCard.loadButtonAttributes(dealRow, pageConfig)
    fetch("/occasion/deals-json?#{query_filter_string}&limit=#{resultNodes.length}", {
      method: 'GET',
      headers: {'Content-Type': 'application/json', 'referer': window.location.href},
      credentials: 'include'
    }).then((res)->
      if !res.ok # make sure xhr succeeded
          throw("Fetch returned statuscode: #{res.statusCode}")
      return res.json()
    ).then((json)->
      cards = Filtering.cardsForResp json
      if cards
        dealRow.classList.remove('deal-load')
        r = 0
        rl = cards.length
        nl = resultNodes.length
        if rl < nl
          hideThemeRow(dealRow)
        else
          totalDeals = if json and json.pagination and json.pagination.count then json.pagination.count else ''
          container = dealRow.closest('.row.pad-row')
          if container
            viewAll = container.querySelector('.view-all')
            if viewAll
              viewAll.textContent = I18n.pluralize totalDeals-0, 'js.modules.merchandising_occasions.see_all_deals_link'
          while r < rl and r < nl
            cardHtml = Filtering.htmlForDeal cards[r]
            if cardHtml
              newCard = document.createRange().createContextualFragment(cardHtml)
              resultNodes[r].replaceWith(newCard)
            r++
          Groupon.Utils.lazyLoadImages()
          GIG.Utils.truncateElements(dealRow)
          Filtering.getCardUi().init(dealRow)
    ).catch((error)-> # Error handling
      hideThemeRow(dealRow)
    )

positionInAppMessages = ()->
  inapp = document.getElementById('ls-in-app-messages')
  dest = document.getElementById('ls-banner-holder')
  cardSelector = ' #result-list > ul > li > .card-ui'
  if inapp and inapp.childNodes.length
    if dest
      dest.appendChild(inapp)
    else if document.querySelector('.giftable-secondary')
      inapp.style.display='block'
    else
      dest = document.querySelectorAll('.standard.new'+cardSelector)[2] || document.querySelectorAll('.standard'+cardSelector)[1] || document.querySelectorAll('.events-page'+cardSelector)[5]
      dest = dest.closest('li') if dest
      if dest
        newLi = document.createElement('li')
        newLi.setAttribute('style', "width:100%;height:auto;")
        dest.after(newLi)
        newLi.appendChild(inapp)
    if dest
      inapp.style.display='block'
    inapp.addEventListener 'click', (ev)->
      if ev.target.closest(".hide-link")
        inapp.remove()

positionDFPMerchandisingBanners = ()->
  dfpBanner = document.getElementById('occasion-desktop-dfp-top-banner-slot')
  cardSelector = ' #result-list > ul > li > .card-ui'
  if dfpBanner and dfpBanner.childNodes.length
    if document.querySelector('.giftable-secondary')
      dfpBanner.style.display='block'
      dfpBanner.style.marginBottom ='20px'
    else
      locator = document.getElementById('result-list')
      locator = locator.closest('section') if locator
      if locator
        locator.insertBefore(dfpBanner, locator.firstChild)
        dfpBanner.style.marginTop='20px'
    if dfpBanner
      dfpBanner.style.display='block'
